/**
 * @desc Store mutations list
 */

// General
export const SET_PAGE_NAVIGATION_IN_PROGRESS_STATE =
  'SET_PAGE_NAVIGATION_IN_PROGRESS_STATE'
export const SET_WINDOW_WIDTH = 'SET_WINDOW_WIDTH'
export const SET_STAY_CONNECTED = 'SET_STAY_CONNECTED'
export const SET_WINDOW_HEIGHT = 'SET_WINDOW_HEIGHT'
export const SET_IS_SCROLLBAR_HIDDEN = 'SET_IS_SCROLLBAR_HIDDEN'
export const SET_MOBILE_BOTTOM_PADDING = 'SET_MOBILE_BOTTOM_PADDING'
export const SET_SCROLL_TOP = 'SET_SCROLL_TOP'
export const SET_SCROLL_IN_PROGRESS_STATE = 'SET_SCROLL_IN_PROGRESS_STATE'
export const SET_SCROLL_TOP_ON_HIDE_SCROLL = 'SET_SCROLL_TOP_ON_HIDE_SCROLL'
export const SET_INITIAL_DEVICE = 'SET_INITIAL_DEVICE'
export const SET_USER_AGENT = 'SET_USER_AGENT'
export const SET_USER_AGENT_DETAILS = 'SET_USER_AGENT_DETAILS'
export const SET_IS_CURRENT_USER_BOT = 'SET_IS_CURRENT_USER_BOT'

// Global Spinner for page loading
export const SET_PAGE_LOADING_STATUS = 'SET_PAGE_LOADING_STATUS'

// Seo
export const SET_PAGE_SEO = 'SET_PAGE_SEO'

// Errors
export const ADD_ERROR_MESSAGE_TO_QUEUE = 'ADD_ERROR_MESSAGE_TO_QUEUE'
export const REMOVE_ERROR_MESSAGE_FROM_QUEUE = 'REMOVE_ERROR_MESSAGE_FROM_QUEUE'
export const CLEAR_ERROR_MESSAGE_QUEUE = 'CLEAR_ERROR_MESSAGE_QUEUE'

/** Third parties **/
export const SET_SWIPER_AS_INSTALLED = 'SET_SWIPER_AS_INSTALLED'

// Router
export const ADD_ITEM_THAT_REQUIRES_CONFIRM = 'ADD_ITEM_THAT_REQUIRES_CONFIRM'
export const REMOVE_ITEM_THAT_REQUIRES_CONFIRM =
  'REMOVE_ITEM_THAT_REQUIRES_CONFIRM'
export const SET_IS_ROUTE_CHANGE_REQUESTED = 'SET_IS_ROUTE_CHANGE_REQUESTED'
export const SET_CHANGE_ROUTE_REQUEST_PROMISE =
  'SET_CHANGE_ROUTE_REQUEST_PROMISE'
export const SET_CHANGE_ROUTE_REQUEST_RESOLVER =
  'SET_CHANGE_ROUTE_REQUEST_RESOLVER'

// Modal
export const ADD_MODAL_NAME_TO_OPENED = 'ADD_MODAL_NAME_TO_OPENED'
export const REMOVE_MODAL_NAME_FROM_OPENED = 'REMOVE_MODAL_NAME_FROM_OPENED'
